export function calculateVatFromGross(
  totalPrice: number,
  vatRate: number
): number {
  const vatAmount = (totalPrice * vatRate) / (100 + vatRate);
  return Math.max(parseFloat(vatAmount.toFixed(2)), 0);
}

export default calculateVatFromGross;
